import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import ManageTableWithDynamicPagination from "../../../Components/TableTemplate/ManageTableWithDynamicPagination";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import ReactLoading from "react-loading";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    numberFormatInt,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO,
    capitalizeFirstLetter
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import { Fragment } from "react";
import Moment from "moment";
import InputError from "../../../Components/InputError/InputError";
import { validatePayrollModal } from './../../../Helpers/Validation/Employees/PayrollValidation';
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllPayroll, deletePayroll } from './../../../Helpers/apiCalls/Employees/PayrollApi';
import { validateHoliday } from './../../../Helpers/Validation/Employees/HolidayValidation';
import { createHoliday, updateHoliday, getAllHoliday, deleteHoliday } from './../../../Helpers/apiCalls/Employees/HolidayApi';
import Footer from "../../../Components/Footer/Footer";

export default function Holiday() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        name: "",
        employee_name: "",
        date_from: "",
        date_to: "",
        user: accountType,
        page: 1
    })
    const [isError, setIsError] = useState({
        name: false,
        date: false,
        type: false,
        
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // const [branches, setBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataCsv, setAllDataCsv] = useState([]);
    const [totalNet, setTotalNet] = useState("0");
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [addDetails, setAddDetails] = useState({})

     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     /* add modal handler */
     const [showAddModal, setShowAddModal] = useState(false);
     const handleShowAddModal = () => setShowAddModal(true);
     const handleCloseAddModal = () => setShowAddModal(false); 
     /* add modal handler */
     const [showEditModal, setShowEditModal] = useState(false);
     const handleShowEditModal = () => setShowEditModal(true);
     const handleCloseEditModal = () => setShowEditModal(false); 
     /* add modal handler */
     const [showViewModal, setShowViewModal] = useState(false);
     const handleShowViewModal = () => setShowViewModal(true);
     const handleCloseViewModal = () => setShowViewModal(false); 

     const [selectedRow, setSelectedRow] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState({
        label: "",
        value: "",
     });
     const [selectedMonthFrom, setSelectedMonthFrom] = useState("");
     const [selectedMonthTo, setSelectedMonthTo] = useState("");
     const today = Moment().format("MM/DD/YYYY");

     
     
     
    
    const excelHeaders = [
        { label: "Payroll Range", key: "payroll_range" },
        { label: "Disbursement Date", key: "disbursement_date" },
        { label: "Type", key: "disbursement_type" },
        { label: "Employee Name", key: "employee_name" },
        { label: "Department", key: "department_name" },
        { label: "Payee ID", key: "payee_id" },
        { label: "Net Pay", key: "grand_total" },
        { label: "Total Working Hours", key: "working_hours" },
        { label: "Rate", key: "rate" },
        { label: "Basic Pay", key: "basic_pay" },
        { label: "Total Wages", key: "total_addition" },
        { label: "Total Deductions", key: "total_deduction" },
        { label: "Transportation Allowance", key: "transportation_allowance" },
        { label: "Other Allowances", key: "other_allowances" },
        { label: "Holiday", key: "holidays" },
        { label: "Other Wages", key: "other_wages" },
        { label: "Philhealth", key: "philhealth" },
        { label: "SSS", key: "sss" },
        { label: "Pagibig", key: "pagibig" },
        { label: "Shortage", key: "shortage" },
        { label: "Cash Advance", key: "cash_advance" },
        { label: "Other Deductions", key: "other_deductions" },
        { label: "SSS Loan", key: "sss_loan" },
        { label: "Pagibig Loan", key: "pagibig_loan" },
        { label: "Remarks", key: "remarks" },
    ];

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleAddModal(e) {
        if(validatePayrollModal(selectedEmployee, selectedMonthFrom, selectedMonthTo, setIsError)) {
            navigate(
                `/payroll/add/${selectedEmployee.value}`, {
                    state: { selectedEmployee: selectedEmployee, date_from: selectedMonthFrom, date_to: selectedMonthTo  },
                }
            )
        }
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);
        setAddDetails(row);
        

        if (e.target.value === "view") {
            handleShowViewModal()
        } else if (e.target.value === "edit") {
            handleShowEditModal()
        } else if (e.target.value === "delete") {
            handleShowDeleteModal();
        }
    }


    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                <option value="view" className="color-options">
                    View
                </option>
                <option value="edit" className="color-options">
                    Edit
                </option>
                <option value="delete" className="color-red">
                    Delete
                </option>
            </Form.Select>
        );
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handleView(row)}
            >
                View
            </button>
        );
    }

    function handleView(row) {
        setSelectedRow(row);
        handleShowViewModal()
    }

    const handleAddChange = (e, type) => {
        if(type === "select") {
            setAddDetails((prevState) => ({
                ...prevState,
                ["employee_id"]: e.value,
                ["employee_id_value"]: {
                    label: e.label,
                    value: e.value,
                }
            }));
        } else {
            const { name, value, checked } = e.target;
            
            
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    }
    
    

    const handleEditChange = (e, type) => {
        if(type === "select") {
            setSelectedRow((prevState) => ({
                ...prevState,
                ["employee_id"]: e.value,
                ["employee_id_value"]: {
                    label: e.label,
                    value: e.value,
                }
            }));
        } else {
            const { name, value, checked } = e.target;
            
            
            setSelectedRow((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    }

    async function fetchEmployees() {

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees(result);
        }
    }

    async function fetchData() {
        setTotalItems(0);
        setAllData([])
        setShowLoader(true);
        setTotalNet("0")

        const response = await getAllHoliday(filterConfig);

        if (response.error) {
            setAllData([])
        } else {
            var allBills = response.data.data.map((bill) => {
                var info = bill;
                info.rateTable = numberFormatInt(bill.rate) + " %";
                info.typeTable = capitalizeFirstLetter(bill.type)
                info.date = Moment(bill.date).format("MMM DD, YYYY");
                
                return info;
            });
            setAllData(allBills)
            setTotalItems(response.data.size)
            setAllDataCsv(allBills)

            // var total = response.data.summary? response.data.summary.total_net : "0";
            // setTotalNet(total);

        }
        setShowLoader(false);
    }

    async function handleDeleteHoliday() {
        setIsClicked(true);
        const response = await deleteHoliday(addDetails.id);
        if (response.data) {
            toast.success("Holiday Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Something went wrong", {
                style: toastStyle(),
            });
        }
    }

    
    async function handleCreateHoliday() {
        if (validateHoliday(addDetails, setIsError)) {
            setIsClicked(true)
            const response = await createHoliday(addDetails);
            
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
        } else {
            toast.error("Please fill in all fields", {
                style: toastStyle(),
            });
        }
    }
    
    async function handleUpdateHoliday() {
        if (validateHoliday(addDetails, setIsError)) {
            setIsClicked(true)
            const response = await updateHoliday(addDetails);
            
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
        } else {
            toast.error("Please fill in all fields", {
                style: toastStyle(),
            });
        }
    }

    useEffect(() => {
        fetchEmployees();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    //DISABLE SCROLL FUNCTION
    function limitScroll() {
        var numericInputs = document.querySelectorAll('.numeric-input');
        numericInputs.forEach(function(input) {
          input.addEventListener('wheel', function(e) {
            e.preventDefault();
          });
        });
      }
      limitScroll();

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> HOLIDAY </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="name"
                            placeholder="Search name"
                            className="search-bar"
                            // onChange={handleOnSearch}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                handleOnSearch(e)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                        <div className="PO-filters">
                            <button
                                className="add-btn"
                                onClick={(e) => handleShowAddModal()}
                            >
                                Add
                            </button>
                        </div>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={"Select Date From"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={"Select Date To"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                            minDate={filterConfig.date_from ? filterConfig.date_from : ""}
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    {/* <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total NET: {numberFormat(totalNet)}
                        </span>
                    </div> */}

                    <div className="below">
                        {/* table */}
                        <ManageTableWithDynamicPagination
                            tableHeaders={[
                                "-",
                                "NAME",
                                "DATE",
                                "ADDON RATE",
                                "TYPE",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "name",
                                "date",
                                "rateTable",
                                "typeTable",
                            ]}
                            tableData={allData}
                            ActionBtn={(row) => ActionBtn(row)}
                            ViewBtn={(row) => ViewBtn(row)}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>

            {/* modals */}
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="holiday"
                onDelete={handleDeleteHoliday}
                isClicked={isClicked}
            />

            <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        ADD HOLIDAY
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">NAME</span>
                                </Row>
                                <Row>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        className="nc-modal-custom-text"
                                        value={addDetails.name}
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    <InputError
                                        isValid={isError.name}
                                        message={"Name is required"}
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">DATE</span>
                                </Row>
                                <Row>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={addDetails.date ? addDetails.date : ""}
                                        name="date"
                                        placeholderText={"Select Date"}
                                        onChange={(date) => {
                                            setAddDetails((prev) => {
                                                return { ...prev, 
                                                    date: date,
                                                };
                                            });
                                        }}
                                        fixedHeight
                                        className="PI-date-btn me-3 form-control"
                                        showYearDropdown
                                        dateFormat="MMM dd, yyyy"
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                    <InputError
                                        isValid={isError.date}
                                        message={"Date is required"}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">Add-on Rate (%)</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Control
                                        type="number"
                                        name="rate"
                                        className="nc-modal-custom-text hide-spinner numeric-input"
                                        value={addDetails.rate}
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    {/* <InputError
                                        isValid={isError.type}
                                        message={"Type is required"}
                                    /> */}
                                </Row>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">Type</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Select
                                        type="select"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Type..."
                                        name="type"
                                        value={addDetails.type}
                                        onChange={(e) => handleAddChange(e)}
                                    >
                                        <option value="" selected hidden>Select</option>
                                        <option value="regular">Regular</option>
                                        <option value="special non-working">Special Non-Working</option>
                                        <option value="special working">Special Working</option>
                                    </Form.Select>
                                    <InputError
                                        isValid={isError.type}
                                        message={"Type is required"}
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive">
                    <button
                        type="button"
                        onClick={handleCloseAddModal}
                        className="button-secondary me-2"
                    >
                        Close
                    </button>
                    {isClicked === true && (
                        <div className="button-primary d-flex justify-content-center">
                            <ReactLoading
                                type="bubbles"
                                color="#FFFFFF"
                                height={50}
                                width={50}
                            />
                        </div>
                    )}
                    {isClicked === false && (
                        <button
                            type="button"
                            onClick={handleCreateHoliday}
                            className="button-primary"
                        >
                            Add
                        </button>
                    )}
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        EDIT HOLIDAY
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">NAME</span>
                                </Row>
                                <Row>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        className="nc-modal-custom-text"
                                        value={addDetails.name}
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    <InputError
                                        isValid={isError.name}
                                        message={"Name is required"}
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">DATE</span>
                                </Row>
                                <Row>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={addDetails.date ? new Date(addDetails.date) : ""}
                                        name="date"
                                        placeholderText={"Select Date"}
                                        onChange={(date) => {
                                            setAddDetails((prev) => {
                                                return { ...prev, 
                                                    date: date,
                                                };
                                            });
                                        }}
                                        fixedHeight
                                        className="PI-date-btn me-3 form-control"
                                        showYearDropdown
                                        dateFormat="MMM dd, yyyy"
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                    <InputError
                                        isValid={isError.date}
                                        message={"Date is required"}
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">Add-on Rate (%)</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Control
                                        type="number"
                                        name="rate"
                                        className="nc-modal-custom-text hide-spinner numeric-input"
                                        value={addDetails.rate ? numberFormatInt(addDetails.rate) : ""}
                                        onChange={(e) => handleAddChange(e)}
                                    />
                                    {/* <InputError
                                        isValid={isError.type}
                                        message={"Type is required"}
                                    /> */}
                                </Row>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">Type</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Select
                                        type="select"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Type..."
                                        name="type"
                                        value={addDetails.type}
                                        onChange={(e) => handleAddChange(e)}
                                    >
                                        <option value="" selected hidden>Select</option>
                                        <option value="regular">Regular</option>
                                        <option value="special non-working">Special Non-Working</option>
                                        <option value="special working">Special Working</option>
                                    </Form.Select>
                                    <InputError
                                        isValid={isError.type}
                                        message={"Type is required"}
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive">
                    <button
                        type="button"
                        onClick={handleCloseEditModal}
                        className="button-secondary me-2"
                    >
                        Close
                    </button>
                    {isClicked === true && (
                        <div className="button-primary d-flex justify-content-center">
                            <ReactLoading
                                type="bubbles"
                                color="#FFFFFF"
                                height={50}
                                width={50}
                            />
                        </div>
                    )}
                    {isClicked === false && (
                        <button
                            type="button"
                            onClick={handleUpdateHoliday}
                            className="button-primary"
                        >
                            Submit
                        </button>
                    )}
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal show={showViewModal} onHide={handleCloseViewModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        VIEW HOLIDAY
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">NAME</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        className="nc-modal-custom-text"
                                        value={selectedRow.name}
                                        disabled
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">DATE</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Control
                                        type="text"
                                        name="date"
                                        className="nc-modal-custom-text"
                                        value={Moment(selectedRow.date).format("MMM DD, YYYY")}
                                        disabled
                                    />
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">Add-on Rate (%)</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Control
                                        type="text"
                                        name="rate"
                                        className="nc-modal-custom-text"
                                        value={selectedRow.rateTable}
                                        disabled
                                    />
                                </Row>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Row>
                                    <span className="PI-modal-label ">Type</span>
                                </Row>
                                <Row className="p-2">
                                    <Form.Control
                                        type="text"
                                        name="type"
                                        className="nc-modal-custom-text"
                                        value={selectedRow.typeTable}
                                        disabled
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive">
                    <button
                        type="button"
                        onClick={handleCloseViewModal}
                        className="button-secondary"
                    >
                        Close
                    </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Footer/>
        </div>
    );
}